import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { pricingFaqs } from '../../data/pricingDetails';
import { site } from '../../data/site';
export function PricingFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const prefersReducedMotion = useReducedMotion();
  return <Section bordered labelledBy="pricing-faq-title" data-id="element-748" data-mp="2rl9fnj3o4zsg">
      <Container data-id="element-749" data-mp="2rm1austcsvi7">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-8" data-id="element-750" data-mp="2rnm5sjjkyggl">
          <div className="lg:col-span-4" data-id="element-751" data-mp="2wjb0o9knn96k">
            <Reveal data-id="element-752" data-mp="31jyxjbvkek8p">
              <h2 id="pricing-faq-title" className="max-w-[12ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-753" data-mp="31k8sldvgvhl9">
                Pricing questions.
              </h2>
              <p className="mt-6 max-w-[38ch] text-body text-muted" data-id="element-754" data-mp="grwva66c3vvk">
                Anything not answered here?{' '}
                <a href={`mailto:${site.email}`} className="text-accent underline decoration-accent/30 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-accent" data-id="element-755" data-mp="qyy45l2dzt0k">
                  Email us
                </a>{' '}
                and you will get a number, not a sales call.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-756" data-mp="84an7p53i4uo">
            <ul className="border-t border-hairline" data-id="element-757" data-mp="3ay4fvn3ks9u">
              {pricingFaqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return <li key={faq.question} className="border-b border-hairline" data-id="element-758" data-mp="3qhgyhjid3uxx" data-mpi={index}>
                    <h3 data-id="element-759" data-mp="3lhvwf07wb6gz">
                      <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`pricing-faq-panel-${index}`} className="group flex w-full cursor-pointer items-start justify-between gap-8 py-7 text-left" data-id="element-760" data-mp="3lg1bvn0jdgdf">
                        <span className="max-w-[40ch] text-[20px] leading-[1.35] tracking-[-0.02em] text-ink" data-id="element-761" data-mp="2wxrgm4rt6z5q">
                          {faq.question}
                        </span>
                        <PlusIcon size={20} aria-hidden="true" className={`mt-1 shrink-0 text-muted transition-transform duration-200 ease-editorial group-hover:text-ink ${isOpen ? 'rotate-45' : ''}`} data-id="element-762" data-mp="3pkvii0vluxda" />
                      </button>
                    </h3>
                    <AnimatePresence initial={false} data-id="element-763" data-mp="cdtq8jch1ofw">
                      {isOpen && <motion.div id={`pricing-faq-panel-${index}`} initial={prefersReducedMotion ? false : {
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={prefersReducedMotion ? {
                    opacity: 0
                  } : {
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.23, 1, 0.32, 1]
                  }} className="overflow-hidden" data-id="element-764" data-mp="h6dbm2hehnv9">
                          <p className="max-w-measure pb-8 pr-10 text-body text-muted" data-id="element-765" data-mp="1ixejbg9kef2q">
                            {faq.answer}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </Container>
    </Section>;
}